module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[34]33.23dd680.woff2";